import type { AxiosInstance } from 'axios';
import axios from 'axios';

import { env } from '../../config/env';
import { shouldUseIndexedServerUrls } from '../../util/shouldUseIndexedServerUrls';

const nonIndexedClient = axios.create({
  baseURL: env.appUrls.p2pServer,
});

const clients: Map<number, AxiosInstance> = new Map();

const createIndexedClient = (serverIndex?: number): AxiosInstance => {
  if (!shouldUseIndexedServerUrls) {
    return nonIndexedClient;
  }

  if (serverIndex === undefined) {
    return createIndexedClient(0);
  }

  const cachedClient = clients.get(serverIndex);

  if (cachedClient) {
    return cachedClient;
  }

  const client = axios.create({
    baseURL: `${env.appUrls.p2pServer}/${serverIndex}`,
  });

  clients.set(serverIndex, client);

  return client;
};

export const getP2pAxiosClient = (serverIndex?: number): AxiosInstance => {
  return createIndexedClient(serverIndex);
};
